exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-567040cc] .md-table-cell {\n  height: 40px;\n}\n.body-list[data-v-567040cc] {\n  margin-top: 150px;\n  min-height: 100px;\n}\n.connected[data-v-567040cc] {\n  color: green !important;\n}\n.disconnected[data-v-567040cc] {\n  color: red !important;\n}\n.custom-paginated-table a[data-v-567040cc] {\n  color: rgba(0, 0, 0, 0.87);\n}\n.md-card-actions.page-footer[data-v-567040cc] {\n  padding-bottom: 0 !important;\n}\n", ""]);

// exports
